import { useState } from "react";
// import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import OrderTableRow from "./OrderTableRow";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";

const OrderData = () => {
  const { orders, isLoading } = useSelector((state) => state.orders);
  const dispatch = useDispatch();

  const [orderData, setOrderData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <TableContainer sx={{ whiteSpace: "nowrap" }}>
      <Table aria-label='customized table'>
        <TableHead
          sx={{
            "&:hover": false,
          }}
        >
          <TableRow>
            <TableCell>Id</TableCell>
            <TableCell>User</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <TextField
                fullWidth
                helperText='Search by id'
                id='id-searchbox'
                label='Id'
                name='searchId'
                // onChange={handleSearch}
              />
            </TableCell>
            <TableCell>
              <TextField
                fullWidth
                helperText='Search by name'
                id='name-searchbox'
                label='User'
                name='searchuser'
                // onChange={handleSearch}
              />
            </TableCell>

            <TableCell>
              <TextField
                fullWidth
                helperText='Search by email'
                id='email-searchbox'
                label='Status'
                name='searchstatus'
                // onChange={handleSearch}
              />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell colSpan={4}>
                <Typography variant='p' align='center'>
                  Loading...
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            <OrderTableRow row={orders}></OrderTableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
    // <Typography>Order data</Typography>
  );
};

export default OrderData;
